module.exports = __webpack_public_path__ + "img/bg3.1d081e74.png";